exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".unit1a .diagram .unit-wrapper.wide{max-width:1183px;padding:44px 0 45px}.unit1a .diagram .unit-wrapper.wide .submit{margin-right:3%}.unit1a .diagram .unit-wrapper.wide .huge-diagram_answers{position:relative;top:-150px;height:170px}.unit1a .diagram .unit-wrapper.wide .short-separator td{height:25px}.unit1a .diagram .unit-wrapper.wide .middle-separator td{height:45px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/1/1a/diagram4/diagram4.scss
// module id = 938
// module chunks = 0